var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('section',{staticClass:"menuSettings"},[_c('CRenderFunction',{staticClass:"py-5",attrs:{"flat":"","contentToRender":_vm.navItems}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }